export const ItemKind = {
  NORMAL: 'NORMAL',
  EQUIPMENT: 'EQUIPMENT',
};

export const ItemKindList = [
  { label: 'Normál', value: ItemKind.NORMAL },
  { label: 'Eszköz', value: ItemKind.EQUIPMENT },
];

export const ItemOwnershipType = {
  OWN: 'OWN',
  CUSTOMER: 'CUSTOMER',
};

export const ItemOwnershipTypeList = [
  { label: 'Saját', value: ItemOwnershipType.OWN },
  { label: 'Ügyfél', value: ItemOwnershipType.CUSTOMER },
];

export const RelatedItemType = {
  ACCESSORY: 'ACCESSORY',
  RELATED: 'RELATED',
};

export const RelatedItemTypeList = [
  { label: 'Kiegészítő termék', value: RelatedItemType.ACCESSORY },
  { label: 'Kapcsolódó termék', value: RelatedItemType.RELATED },
];
